import { render, staticRenderFns } from "./emailSign.vue?vue&type=template&id=618a78b6&scoped=true&"
import script from "./emailSign.vue?vue&type=script&lang=js&"
export * from "./emailSign.vue?vue&type=script&lang=js&"
import style0 from "./emailSign.vue?vue&type=style&index=0&id=618a78b6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "618a78b6",
  null
  
)

export default component.exports